module.exports = __webpack_public_path__ + "media/images/gallery/constellations/leo_minor/lmi_gal-634276f7f57b954d45ef6d654285ad81.gif";